<template>
  <div class="tw-w-full tw-p-0">
    <div class="tw-p-2 tw-justify-between colapse-area colapse">
      <div class="tw-flex">
        <div class="tw-mr-4 tw-flex tw-items-center">
          <span class="tw-font-bold tw-text-sm tw-bg-white tw-text-blue-700 tw-rounded-full tw-px-2 tw-py-0.5 tw-inline-block">{{ installmentNumber }}</span>
        </div>
        <div v-if="headerData" class="tw-flex tw-flex-col tw-gap-1">
          <div v-for="item in headerData.items" :key="item.id" class="tw-mb-2">
            <div v-for="(label, fieldName) in labelsOutsideRow" :key="fieldName" class="tw-block">
              <template v-if="fieldName !== 'oldDate' || item[fieldName]">
                <span class="tw-font-medium">{{ label }}:</span>
                <span class="tw-ml-2">
                  <span v-if="fieldName === 'nominalValue'">
                    {{ $toLocaleStringBr(item[fieldName]) }}
                  </span>
                  <span v-else>
                    {{ item[fieldName] }}
                  </span>
                </span>
              </template>
            </div>
            <div class="tw-flex tw-gap-4">
              <div class="tw-block">
                <span class="tw-font-medium">{{ $gettext("TOTAL_CHARGES") }}:</span>
                <span class="tw-ml-2">{{ $toLocaleStringBr(sumLabelsInRow(item)) }}</span>
              </div>
              <div v-for="(label, fieldName) in labelsInRow" :key="fieldName" class="tw-block">
                <span >{{ '|' }}</span>
                <span class="tw-font-medium tw-ml-3">{{ getInitials(label) }}:</span>
                <span class="tw-ml-2">{{  $toLocaleStringBr(item[fieldName]) }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <q-btn flat icon="mdi-calendar-plus" class="tw-text-warmGray-100" :disable="shouldDisableExtend(currentItem)"
          @click="handleExtendClick">
          <q-tooltip anchor="top middle" self="bottom middle">{{ $gettext('EXTEND') }}</q-tooltip>
        </q-btn>
        <q-btn flat icon="picture_as_pdf" class="tw-text-warmGray-100" :disable="shouldDisableVisualize(currentItem)"
          @click="handleVisualizeClick">
          <q-tooltip anchor="top middle" self="bottom middle">
            {{ $gettext('VISUALIZE_INVOICE_DOCUMENT') }}
          </q-tooltip>
        </q-btn>
        <q-btn flat icon="mdi-arrow-collapse-vertical" class="tw-text-warmGray-100" @click="openCloseTable">
          <q-tooltip anchor="top middle" self="bottom middle">{{ $gettext('EXPAND') }}</q-tooltip>
        </q-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'HeaderColapseTableInstallment',
  props: {
    headerData: Object,
    shouldDisableExtend: Function,
    shouldDisableVisualize: Function,
    openExtendModal: Function,
    openInvoiceManager: Function
  },
  computed: {
    currentItem () {
      return this.headerData?.items?.[0] || {}
    },
    labelsInRow () {
      if (this.headerData?.labels) {
        const filteredLabels = {}
        this.inRowFields.forEach(field => {
          if (this.headerData.labels[field]) {
            filteredLabels[field] = this.headerData.labels[field] || 0
          }
        })
        return filteredLabels
      }
      return {}
    },
    labelsOutsideRow () {
      const requiredFields = [
        'dueDate',
        'oldDate',
        'nominalValue',
        'agreementInvoiceStatusDesc'
      ]
      if (this.headerData?.labels) {
        const filteredLabels = {}
        requiredFields.filter(f => !this.inRowFields.includes(f)).forEach(field => {
          if (this.headerData.labels[field]) {
            filteredLabels[field] = this.headerData.labels[field]
          }
        })
        return filteredLabels
      }
      return {}
    },

    installmentNumber () {
      return this.headerData?.installmentNumber || 1
    }
  }
})

class HeaderColapseTableInstallment extends Vue {
  inRowFields = ['feesAfterDiscount', 'fineAfterDiscount', 'correctionAfterDiscount', 'interest']

  sumLabelsInRow (item) {
    const result = this.inRowFields.reduce((acc, field) => {
      const raw = item[field]
      const value = typeof raw === 'string'
        ? parseFloat(raw.replace(',', '.')) || 0
        : parseFloat(raw) || 0
      return acc + value
    }, 0)
    return result
  }

  getInitials (label) {
    return label
      .split(' ')
      .map(word => word[0])
      .join('')
      .toUpperCase()
  }

  handleExtendClick () {
    if (this.openExtendModal) {
      this.openExtendModal(this.currentItem)
    }
  }

  handleVisualizeClick () {
    if (this.openInvoiceManager) {
      this.openInvoiceManager(this.currentItem)
    }
  }

  openCloseTable () {
    this.$emit('colapse')
  }
}
export default HeaderColapseTableInstallment
</script>

<style lang="scss" scoped>
@import "tailwindcss/utilities";

.colapse-area {
  background-color: #5898aa;
  display: flex;

}

.colapse {
  color: #fff;
}
</style>
